import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _49a8189a = () => interopDefault(import('../../../pages/metals.vue' /* webpackChunkName: "pages/metals" */))
const _39399e3e = () => interopDefault(import('../../../pages/collections.vue' /* webpackChunkName: "pages/collections" */))
const _438d64dc = () => interopDefault(import('../../../pages/configurator.vue' /* webpackChunkName: "pages/configurator" */))
const _2b136dc6 = () => interopDefault(import('../../../pages/diamonds.vue' /* webpackChunkName: "pages/diamonds" */))
const _5856888a = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _43e0acfd = () => interopDefault(import('../../../pages/engagementRingsFastDelivery.vue' /* webpackChunkName: "pages/engagementRingsFastDelivery" */))
const _953488bc = () => interopDefault(import('../../../pages/engraving.vue' /* webpackChunkName: "pages/engraving" */))
const _c3b527b0 = () => interopDefault(import('../../../pages/memoireRings.vue' /* webpackChunkName: "pages/memoireRings" */))
const _6b27699c = () => interopDefault(import('../../../pages/imprint.vue' /* webpackChunkName: "pages/imprint" */))
const _370bb33d = () => interopDefault(import('../../../pages/diamondJewelry.vue' /* webpackChunkName: "pages/diamondJewelry" */))
const _f0c52cb4 = () => interopDefault(import('../../../pages/shops.vue' /* webpackChunkName: "pages/shops" */))
const _7fa2b832 = () => interopDefault(import('../../../pages/shoplogout.vue' /* webpackChunkName: "pages/shoplogout" */))
const _0e290d3b = () => interopDefault(import('../../../pages/magazine.vue' /* webpackChunkName: "pages/magazine" */))
const _204c2ee9 = () => interopDefault(import('../../../pages/memoireRingsFullSizeMemoires.vue' /* webpackChunkName: "pages/memoireRingsFullSizeMemoires" */))
const _e2f3e270 = () => interopDefault(import('../../../pages/memoireRingsGrowingMemoires.vue' /* webpackChunkName: "pages/memoireRingsGrowingMemoires" */))
const _3fc61b50 = () => interopDefault(import('../../../pages/onlineConsulting.vue' /* webpackChunkName: "pages/onlineConsulting" */))
const _97c63e14 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _7a115b31 = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _95e7c546 = () => interopDefault(import('../../../pages/consulting.vue' /* webpackChunkName: "pages/consulting" */))
const _5117eeab = () => interopDefault(import('../../../pages/ringSizes.vue' /* webpackChunkName: "pages/ringSizes" */))
const _3be8a369 = () => interopDefault(import('../../../pages/sapphire.vue' /* webpackChunkName: "pages/sapphire" */))
const _374ec160 = () => interopDefault(import('../../../pages/shopIndividualBeBrussels.vue' /* webpackChunkName: "pages/shopIndividualBeBrussels" */))
const _dbecf444 = () => interopDefault(import('../../../pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _f380c96e = () => interopDefault(import('../../../pages/styles.vue' /* webpackChunkName: "pages/styles" */))
const _794394f5 = () => interopDefault(import('../../../pages/sweepstake.vue' /* webpackChunkName: "pages/sweepstake" */))
const _5b2a6014 = () => interopDefault(import('../../../pages/weddingRings.vue' /* webpackChunkName: "pages/weddingRings" */))
const _32a1456b = () => interopDefault(import('../../../pages/urbanMining.vue' /* webpackChunkName: "pages/urbanMining" */))
const _42cad228 = () => interopDefault(import('../../../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _4a953bed = () => interopDefault(import('../../../pages/engagementRings.vue' /* webpackChunkName: "pages/engagementRings" */))
const _40971f7e = () => interopDefault(import('../../../pages/zweiklang.vue' /* webpackChunkName: "pages/zweiklang" */))
const _7591b796 = () => interopDefault(import('../../../pages/zweiklangConfigurator.vue' /* webpackChunkName: "pages/zweiklangConfigurator" */))
const _30524846 = () => interopDefault(import('../../../pages/aboutPackaging.vue' /* webpackChunkName: "pages/aboutPackaging" */))
const _47784305 = () => interopDefault(import('../../../pages/aboutRjc.vue' /* webpackChunkName: "pages/aboutRjc" */))
const _2cafaf56 = () => interopDefault(import('../../../pages/collectionsEngagementRings.vue' /* webpackChunkName: "pages/collectionsEngagementRings" */))
const _53a97f10 = () => interopDefault(import('../../../pages/configuratorV2.vue' /* webpackChunkName: "pages/configuratorV2" */))
const _7915d67d = () => interopDefault(import('../../../pages/engagementRingsEntwined.vue' /* webpackChunkName: "pages/engagementRingsEntwined" */))
const _5d211e32 = () => interopDefault(import('../../../pages/engagementRingsEssentials.vue' /* webpackChunkName: "pages/engagementRingsEssentials" */))
const _6bcf2fc9 = () => interopDefault(import('../../../pages/engagementRingsHalo.vue' /* webpackChunkName: "pages/engagementRingsHalo" */))
const _70ea36a5 = () => interopDefault(import('../../../pages/engagementRingsTensionRing.vue' /* webpackChunkName: "pages/engagementRingsTensionRing" */))
const _653a889c = () => interopDefault(import('../../../pages/engravingFonts.vue' /* webpackChunkName: "pages/engravingFonts" */))
const _7ef91d18 = () => interopDefault(import('../../../pages/engravingInspiration.vue' /* webpackChunkName: "pages/engravingInspiration" */))
const _73fa276a = () => interopDefault(import('../../../pages/engravingSayings.vue' /* webpackChunkName: "pages/engravingSayings" */))
const _64246aee = () => interopDefault(import('../../../pages/engravingSymbols.vue' /* webpackChunkName: "pages/engravingSymbols" */))
const _3e82052b = () => interopDefault(import('../../../pages/memoireRingsBestseller.vue' /* webpackChunkName: "pages/memoireRingsBestseller" */))
const _402abf4f = () => interopDefault(import('../../../pages/memoireRingsBudgetHigh.vue' /* webpackChunkName: "pages/memoireRingsBudgetHigh" */))
const _4c0ae537 = () => interopDefault(import('../../../pages/memoireRingsBudgetLow.vue' /* webpackChunkName: "pages/memoireRingsBudgetLow" */))
const _6abcc33c = () => interopDefault(import('../../../pages/memoireRingsBudgetMedium.vue' /* webpackChunkName: "pages/memoireRingsBudgetMedium" */))
const _2cf67837 = () => interopDefault(import('../../../pages/memoireRingsCheap.vue' /* webpackChunkName: "pages/memoireRingsCheap" */))
const _0c1785ac = () => interopDefault(import('../../../pages/memoireRingsColored.vue' /* webpackChunkName: "pages/memoireRingsColored" */))
const _c9bc4eb0 = () => interopDefault(import('../../../pages/memoireRingsGold.vue' /* webpackChunkName: "pages/memoireRingsGold" */))
const _c0b49cd4 = () => interopDefault(import('../../../pages/memoireRingsHalfSetMemories.vue' /* webpackChunkName: "pages/memoireRingsHalfSetMemories" */))
const _b4c00718 = () => interopDefault(import('../../../pages/memoireRingsPlatinum.vue' /* webpackChunkName: "pages/memoireRingsPlatinum" */))
const _96e2b24e = () => interopDefault(import('../../../pages/memoireRingsRedgold.vue' /* webpackChunkName: "pages/memoireRingsRedgold" */))
const _462242f7 = () => interopDefault(import('../../../pages/memoireRingsRosegold.vue' /* webpackChunkName: "pages/memoireRingsRosegold" */))
const _07e9aa49 = () => interopDefault(import('../../../pages/memoireRingsRingsets.vue' /* webpackChunkName: "pages/memoireRingsRingsets" */))
const _5f0967a0 = () => interopDefault(import('../../../pages/memoireRingsSignature.vue' /* webpackChunkName: "pages/memoireRingsSignature" */))
const _5344e9f6 = () => interopDefault(import('../../../pages/memoireRingsSlim.vue' /* webpackChunkName: "pages/memoireRingsSlim" */))
const _88c5de06 = () => interopDefault(import('../../../pages/memoireRingsConfigurator.vue' /* webpackChunkName: "pages/memoireRingsConfigurator" */))
const _44a22a86 = () => interopDefault(import('../../../pages/memoireRingsExclusive.vue' /* webpackChunkName: "pages/memoireRingsExclusive" */))
const _b3bd072e = () => interopDefault(import('../../../pages/memoireRingsAsWeddingRings.vue' /* webpackChunkName: "pages/memoireRingsAsWeddingRings" */))
const _948dbade = () => interopDefault(import('../../../pages/memoireRingsWhite.vue' /* webpackChunkName: "pages/memoireRingsWhite" */))
const _7e588e6e = () => interopDefault(import('../../../pages/diamondJewelrySignet.vue' /* webpackChunkName: "pages/diamondJewelrySignet" */))
const _7fffc091 = () => interopDefault(import('../../../pages/diamondJewelry025Carat.vue' /* webpackChunkName: "pages/diamondJewelry025Carat" */))
const _793ea339 = () => interopDefault(import('../../../pages/diamondJewelry050Carat.vue' /* webpackChunkName: "pages/diamondJewelry050Carat" */))
const _b9efee8a = () => interopDefault(import('../../../pages/diamondJewelry070Carat.vue' /* webpackChunkName: "pages/diamondJewelry070Carat" */))
const _cf0e6a5a = () => interopDefault(import('../../../pages/diamondJewelry100Carat.vue' /* webpackChunkName: "pages/diamondJewelry100Carat" */))
const _0b24385e = () => interopDefault(import('../../../pages/diamondJewelryBracelets.vue' /* webpackChunkName: "pages/diamondJewelryBracelets" */))
const _143e3600 = () => interopDefault(import('../../../pages/diamondJewelryBestseller.vue' /* webpackChunkName: "pages/diamondJewelryBestseller" */))
const _15e6f024 = () => interopDefault(import('../../../pages/diamondJewelryBudgetHigh.vue' /* webpackChunkName: "pages/diamondJewelryBudgetHigh" */))
const _836a747c = () => interopDefault(import('../../../pages/diamondJewelryBudgetLow.vue' /* webpackChunkName: "pages/diamondJewelryBudgetLow" */))
const _2214edf7 = () => interopDefault(import('../../../pages/diamondJewelryBudgetMedium.vue' /* webpackChunkName: "pages/diamondJewelryBudgetMedium" */))
const _1c2780f8 = () => interopDefault(import('../../../pages/diamondJewelryCollectionRings.vue' /* webpackChunkName: "pages/diamondJewelryCollectionRings" */))
const _13106092 = () => interopDefault(import('../../../pages/diamondJewelryConfigurator.vue' /* webpackChunkName: "pages/diamondJewelryConfigurator" */))
const _5583951a = () => interopDefault(import('../../../pages/diamondJewelryDelicateJewels.vue' /* webpackChunkName: "pages/diamondJewelryDelicateJewels" */))
const _5b3eee8a = () => interopDefault(import('../../../pages/diamondJewelryEarrings.vue' /* webpackChunkName: "pages/diamondJewelryEarrings" */))
const _73b76326 = () => interopDefault(import('../../../pages/diamondJewelryColliers.vue' /* webpackChunkName: "pages/diamondJewelryColliers" */))
const _923be9de = () => interopDefault(import('../../../pages/diamondJewelryExclusive.vue' /* webpackChunkName: "pages/diamondJewelryExclusive" */))
const _3ab48d3d = () => interopDefault(import('../../../pages/diamondJewelryGold.vue' /* webpackChunkName: "pages/diamondJewelryGold" */))
const _1cec5e89 = () => interopDefault(import('../../../pages/diamondJewelryPlatinum.vue' /* webpackChunkName: "pages/diamondJewelryPlatinum" */))
const _65d32e24 = () => interopDefault(import('../../../pages/diamondJewelryRedgold.vue' /* webpackChunkName: "pages/diamondJewelryRedgold" */))
const _8522b5e8 = () => interopDefault(import('../../../pages/diamondJewelryRosegold.vue' /* webpackChunkName: "pages/diamondJewelryRosegold" */))
const _16be7cae = () => interopDefault(import('../../../pages/diamondJewelrySets.vue' /* webpackChunkName: "pages/diamondJewelrySets" */))
const _5d6d6faa = () => interopDefault(import('../../../pages/diamondJewelrySignature.vue' /* webpackChunkName: "pages/diamondJewelrySignature" */))
const _2a17aefc = () => interopDefault(import('../../../pages/diamondJewelryWhitegold.vue' /* webpackChunkName: "pages/diamondJewelryWhitegold" */))
const _0a222abd = () => interopDefault(import('../../../pages/aboutSustainability.vue' /* webpackChunkName: "pages/aboutSustainability" */))
const _ecab62f2 = () => interopDefault(import('../../../pages/aboutPhilosophy.vue' /* webpackChunkName: "pages/aboutPhilosophy" */))
const _aac1d8ac = () => interopDefault(import('../../../pages/aboutJewelryManufacturing.vue' /* webpackChunkName: "pages/aboutJewelryManufacturing" */))
const _9419e04e = () => interopDefault(import('../../../pages/aboutQuality.vue' /* webpackChunkName: "pages/aboutQuality" */))
const _57b4b154 = () => interopDefault(import('../../../pages/aboutDesign.vue' /* webpackChunkName: "pages/aboutDesign" */))
const _64604a8f = () => interopDefault(import('../../../pages/aboutService.vue' /* webpackChunkName: "pages/aboutService" */))
const _a9cc87e0 = () => interopDefault(import('../../../pages/aboutWeddingRingManufacturing.vue' /* webpackChunkName: "pages/aboutWeddingRingManufacturing" */))
const _058f190d = () => interopDefault(import('../../../pages/ringSizesCalculator.vue' /* webpackChunkName: "pages/ringSizesCalculator" */))
const _a8aa61da = () => interopDefault(import('../../../pages/ringSizesTable.vue' /* webpackChunkName: "pages/ringSizesTable" */))
const _6b5d9f82 = () => interopDefault(import('../../../pages/stylesIndividualStyle.vue' /* webpackChunkName: "pages/stylesIndividualStyle" */))
const _65e7d859 = () => interopDefault(import('../../../pages/weddingRingsBlack.vue' /* webpackChunkName: "pages/weddingRingsBlack" */))
const _3e7c7e17 = () => interopDefault(import('../../../pages/weddingRingsFinishes.vue' /* webpackChunkName: "pages/weddingRingsFinishes" */))
const _3ca1010e = () => interopDefault(import('../../../pages/weddingRingsBestseller.vue' /* webpackChunkName: "pages/weddingRingsBestseller" */))
const _6b531040 = () => interopDefault(import('../../../pages/weddingRingsForestGreen.vue' /* webpackChunkName: "pages/weddingRingsForestGreen" */))
const _394f8cc6 = () => interopDefault(import('../../../pages/weddingRingsBudgetHigh.vue' /* webpackChunkName: "pages/weddingRingsBudgetHigh" */))
const _0f3de929 = () => interopDefault(import('../../../pages/weddingRingsBudgetLow.vue' /* webpackChunkName: "pages/weddingRingsBudgetLow" */))
const _5859bd30 = () => interopDefault(import('../../../pages/weddingRingsBudgetMedium.vue' /* webpackChunkName: "pages/weddingRingsBudgetMedium" */))
const _b09ba6fa = () => interopDefault(import('../../../pages/weddingRingsCarbon.vue' /* webpackChunkName: "pages/weddingRingsCarbon" */))
const _9c1af71e = () => interopDefault(import('../../../pages/weddingRingsCertificate.vue' /* webpackChunkName: "pages/weddingRingsCertificate" */))
const _49552fcb = () => interopDefault(import('../../../pages/weddingRingsConfigurator.vue' /* webpackChunkName: "pages/weddingRingsConfigurator" */))
const _7055c511 = () => interopDefault(import('../../../pages/weddingRingsCrown.vue' /* webpackChunkName: "pages/weddingRingsCrown" */))
const _96c7ef96 = () => interopDefault(import('../../../pages/weddingRingsDiamonds.vue' /* webpackChunkName: "pages/weddingRingsDiamonds" */))
const _24cf409e = () => interopDefault(import('../../../pages/weddingRingsGayLesbianCouples.vue' /* webpackChunkName: "pages/weddingRingsGayLesbianCouples" */))
const _07d52e78 = () => interopDefault(import('../../../pages/weddingRingsExclusive.vue' /* webpackChunkName: "pages/weddingRingsExclusive" */))
const _1e7a1bba = () => interopDefault(import('../../../pages/weddingRingsFancy.vue' /* webpackChunkName: "pages/weddingRingsFancy" */))
const _bc9b9aec = () => interopDefault(import('../../../pages/weddingRingsFrameSettings.vue' /* webpackChunkName: "pages/weddingRingsFrameSettings" */))
const _e7e576b8 = () => interopDefault(import('../../../pages/weddingRingsPlain.vue' /* webpackChunkName: "pages/weddingRingsPlain" */))
const _2b1d4529 = () => interopDefault(import('../../../pages/weddingRingsCheap.vue' /* webpackChunkName: "pages/weddingRingsCheap" */))
const _b956b514 = () => interopDefault(import('../../../pages/weddingRingsGold.vue' /* webpackChunkName: "pages/weddingRingsGold" */))
const _2f718803 = () => interopDefault(import('../../../pages/weddingRingsHearts.vue' /* webpackChunkName: "pages/weddingRingsHearts" */))
const _ae029228 = () => interopDefault(import('../../../pages/weddingRingsClassic.vue' /* webpackChunkName: "pages/weddingRingsClassic" */))
const _7378d9a0 = () => interopDefault(import('../../../pages/weddingRingsMen.vue' /* webpackChunkName: "pages/weddingRingsMen" */))
const _fdc2550c = () => interopDefault(import('../../../pages/weddingRingsMillgrif.vue' /* webpackChunkName: "pages/weddingRingsMillgrif" */))
const _43cf7135 = () => interopDefault(import('../../../pages/weddingRingsModern.vue' /* webpackChunkName: "pages/weddingRingsModern" */))
const _4a28af6b = () => interopDefault(import('../../../pages/weddingRingsMokumeGane.vue' /* webpackChunkName: "pages/weddingRingsMokumeGane" */))
const _ea389b7c = () => interopDefault(import('../../../pages/weddingRingsPlatinum.vue' /* webpackChunkName: "pages/weddingRingsPlatinum" */))
const _1df07792 = () => interopDefault(import('../../../pages/weddingRingsRingSets.vue' /* webpackChunkName: "pages/weddingRingsRingSets" */))
const _7794016a = () => interopDefault(import('../../../pages/weddingRingsRedgold.vue' /* webpackChunkName: "pages/weddingRingsRedgold" */))
const _2b65f8c5 = () => interopDefault(import('../../../pages/weddingRingsRosegold.vue' /* webpackChunkName: "pages/weddingRingsRosegold" */))
const _0138ca60 = () => interopDefault(import('../../../pages/weddingRingsSecretHeart.vue' /* webpackChunkName: "pages/weddingRingsSecretHeart" */))
const _223c6b92 = () => interopDefault(import('../../../pages/weddingRingsSignature.vue' /* webpackChunkName: "pages/weddingRingsSignature" */))
const _42df505a = () => interopDefault(import('../../../pages/weddingRingsSlim.vue' /* webpackChunkName: "pages/weddingRingsSlim" */))
const _0e5b7d63 = () => interopDefault(import('../../../pages/weddingRingsStackingRings.vue' /* webpackChunkName: "pages/weddingRingsStackingRings" */))
const _cda535bc = () => interopDefault(import('../../../pages/weddingRingsStarrySky.vue' /* webpackChunkName: "pages/weddingRingsStarrySky" */))
const _42bb0da7 = () => interopDefault(import('../../../pages/weddingRingsTensionRings.vue' /* webpackChunkName: "pages/weddingRingsTensionRings" */))
const _989ed414 = () => interopDefault(import('../../../pages/weddingRingstrisets.vue' /* webpackChunkName: "pages/weddingRingstrisets" */))
const _894ab894 = () => interopDefault(import('../../../pages/weddingRingsTwoColors.vue' /* webpackChunkName: "pages/weddingRingsTwoColors" */))
const _458738d8 = () => interopDefault(import('../../../pages/weddingRingsWomen.vue' /* webpackChunkName: "pages/weddingRingsWomen" */))
const _6eae7d2d = () => interopDefault(import('../../../pages/weddingRingsWaveDesign.vue' /* webpackChunkName: "pages/weddingRingsWaveDesign" */))
const _7b0ad263 = () => interopDefault(import('../../../pages/weddingRingsWhitegold.vue' /* webpackChunkName: "pages/weddingRingsWhitegold" */))
const _448d9941 = () => interopDefault(import('../../../pages/engagementRings025Carat.vue' /* webpackChunkName: "pages/engagementRings025Carat" */))
const _3dcc7be9 = () => interopDefault(import('../../../pages/engagementRings050Carat.vue' /* webpackChunkName: "pages/engagementRings050Carat" */))
const _6795e16b = () => interopDefault(import('../../../pages/engagementRings070Carat.vue' /* webpackChunkName: "pages/engagementRings070Carat" */))
const _5d06a383 = () => interopDefault(import('../../../pages/engagementRings100Carat.vue' /* webpackChunkName: "pages/engagementRings100Carat" */))
const _268ebaa0 = () => interopDefault(import('../../../pages/engagementRingsBestseller.vue' /* webpackChunkName: "pages/engagementRingsBestseller" */))
const _6356eed7 = () => interopDefault(import('../../../pages/engagementRingsDiamond.vue' /* webpackChunkName: "pages/engagementRingsDiamond" */))
const _233d4658 = () => interopDefault(import('../../../pages/engagementRingsBudgetHigh.vue' /* webpackChunkName: "pages/engagementRingsBudgetHigh" */))
const _e90ff9dc = () => interopDefault(import('../../../pages/engagementRingsBudgetLow.vue' /* webpackChunkName: "pages/engagementRingsBudgetLow" */))
const _74b222b2 = () => interopDefault(import('../../../pages/engagementRingsBudgetMedium.vue' /* webpackChunkName: "pages/engagementRingsBudgetMedium" */))
const _34cf91d6 = () => interopDefault(import('../../../pages/engagementRingsClassic.vue' /* webpackChunkName: "pages/engagementRingsClassic" */))
const _10b4fb70 = () => interopDefault(import('../../../pages/engagementRingsCollectionRings.vue' /* webpackChunkName: "pages/engagementRingsCollectionRings" */))
const _92bb3d7c = () => interopDefault(import('../../../pages/engagementRingsConfigurator.vue' /* webpackChunkName: "pages/engagementRingsConfigurator" */))
const _22df3598 = () => interopDefault(import('../../../pages/engagementRingsDainty.vue' /* webpackChunkName: "pages/engagementRingsDainty" */))
const _0b328d2c = () => interopDefault(import('../../../pages/engagementRingsDiamonds.vue' /* webpackChunkName: "pages/engagementRingsDiamonds" */))
const _f7e16f3e = () => interopDefault(import('../../../pages/engagementRingsExclusive.vue' /* webpackChunkName: "pages/engagementRingsExclusive" */))
const _3ee0688c = () => interopDefault(import('../../../pages/engagementRingsFancy.vue' /* webpackChunkName: "pages/engagementRingsFancy" */))
const _302b8426 = () => interopDefault(import('../../../pages/engagementRingsGold.vue' /* webpackChunkName: "pages/engagementRingsGold" */))
const _708f3389 = () => interopDefault(import('../../../pages/engagementRingsHeart.vue' /* webpackChunkName: "pages/engagementRingsHeart" */))
const _8d3e7028 = () => interopDefault(import('../../../pages/engagementRingsModern.vue' /* webpackChunkName: "pages/engagementRingsModern" */))
const _3d0b918e = () => interopDefault(import('../../../pages/engagementRingsPlatinum.vue' /* webpackChunkName: "pages/engagementRingsPlatinum" */))
const _39130ff6 = () => interopDefault(import('../../../pages/engagementRingsPrincess.vue' /* webpackChunkName: "pages/engagementRingsPrincess" */))
const _00cf7f74 = () => interopDefault(import('../../../pages/engagementRingsRedgold.vue' /* webpackChunkName: "pages/engagementRingsRedgold" */))
const _fc070488 = () => interopDefault(import('../../../pages/engagementRingsRosegold.vue' /* webpackChunkName: "pages/engagementRingsRosegold" */))
const _c312f50a = () => interopDefault(import('../../../pages/engagementRingsSignature.vue' /* webpackChunkName: "pages/engagementRingsSignature" */))
const _7f88614e = () => interopDefault(import('../../../pages/engagementRingsSolitaire.vue' /* webpackChunkName: "pages/engagementRingsSolitaire" */))
const _49924b29 = () => interopDefault(import('../../../pages/engagementRingsVintage.vue' /* webpackChunkName: "pages/engagementRingsVintage" */))
const _11762768 = () => interopDefault(import('../../../pages/engagementRingsWhitegold.vue' /* webpackChunkName: "pages/engagementRingsWhitegold" */))
const _484d72f0 = () => interopDefault(import('../../../pages/weddingRingsCeramic.vue' /* webpackChunkName: "pages/weddingRingsCeramic" */))
const _dc9ca502 = () => interopDefault(import('../../../pages/weddingRingsFacetes.vue' /* webpackChunkName: "pages/weddingRingsFacetes" */))
const _5097b493 = () => interopDefault(import('../../../pages/weddingRingsFacettedConnections.vue' /* webpackChunkName: "pages/weddingRingsFacettedConnections" */))
const _3480654b = () => interopDefault(import('../../../pages/weddingRingsMorningGlow.vue' /* webpackChunkName: "pages/weddingRingsMorningGlow" */))
const _05350ad1 = () => interopDefault(import('../../../pages/weddingRingsNaturalBeige.vue' /* webpackChunkName: "pages/weddingRingsNaturalBeige" */))
const _07b21fd0 = () => interopDefault(import('../../../pages/weddingRingsPolar.vue' /* webpackChunkName: "pages/weddingRingsPolar" */))
const _587cc6e2 = () => interopDefault(import('../../../pages/aboutPlantMyTree.vue' /* webpackChunkName: "pages/aboutPlantMyTree" */))
const _146d8d5f = () => interopDefault(import('../../../pages/diamondJewelryPresentsYearly.vue' /* webpackChunkName: "pages/diamondJewelryPresentsYearly" */))
const _043c5abd = () => interopDefault(import('../../../pages/diamondJewelryPresentsChristmas.vue' /* webpackChunkName: "pages/diamondJewelryPresentsChristmas" */))
const _040c0918 = () => interopDefault(import('../../../pages/diamondJewelryPresentsMother.vue' /* webpackChunkName: "pages/diamondJewelryPresentsMother" */))
const _dfda0a9e = () => interopDefault(import('../../../pages/diamondJewelryPresentsValentine.vue' /* webpackChunkName: "pages/diamondJewelryPresentsValentine" */))
const _2f2c8a8e = () => interopDefault(import('../../../pages/diamondJewelryPresentsWomen.vue' /* webpackChunkName: "pages/diamondJewelryPresentsWomen" */))
const _2e33dc61 = () => interopDefault(import('../../../pages/weddingRingsStylesCool.vue' /* webpackChunkName: "pages/weddingRingsStylesCool" */))
const _e66f0c72 = () => interopDefault(import('../../../pages/weddingRingsStylesCreative.vue' /* webpackChunkName: "pages/weddingRingsStylesCreative" */))
const _c7f15b54 = () => interopDefault(import('../../../pages/weddingRingsStylesElegant.vue' /* webpackChunkName: "pages/weddingRingsStylesElegant" */))
const _77f45e25 = () => interopDefault(import('../../../pages/weddingRingsStylesLuxury.vue' /* webpackChunkName: "pages/weddingRingsStylesLuxury" */))
const _23e6e741 = () => interopDefault(import('../../../pages/weddingRingsStylesNatural.vue' /* webpackChunkName: "pages/weddingRingsStylesNatural" */))
const _b7be2aee = () => interopDefault(import('../../../pages/weddingRingsStylesRomantic.vue' /* webpackChunkName: "pages/weddingRingsStylesRomantic" */))
const _7da9deea = () => interopDefault(import('../../../pages/weddingRingsStylesUrban.vue' /* webpackChunkName: "pages/weddingRingsStylesUrban" */))
const _4f8b36db = () => interopDefault(import('../../../pages/_item.vue' /* webpackChunkName: "pages/_item" */))
const _4935da0d = () => interopDefault(import('../../../pages/_shopsDetails.vue' /* webpackChunkName: "pages/_shopsDetails" */))
const _271d429b = () => interopDefault(import('../../../pages/_shoplogin.vue' /* webpackChunkName: "pages/_shoplogin" */))
const _793b1fb6 = () => interopDefault(import('../../../pages/_wishlistDetails.vue' /* webpackChunkName: "pages/_wishlistDetails" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/alloys/",
    component: _49a8189a,
    pathToRegexpOptions: {"strict":true},
    name: "metals___nl"
  }, {
    path: "/collecties/",
    component: _39399e3e,
    pathToRegexpOptions: {"strict":true},
    name: "collections___nl"
  }, {
    path: "/configurator/",
    component: _438d64dc,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___nl"
  }, {
    path: "/diamanten/",
    component: _2b136dc6,
    pathToRegexpOptions: {"strict":true},
    name: "diamonds___nl"
  }, {
    path: "/en/",
    component: _5856888a,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/engagementRingsFastDelivery/",
    component: _43e0acfd,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFastDelivery___nl"
  }, {
    path: "/engraving/",
    component: _953488bc,
    pathToRegexpOptions: {"strict":true},
    name: "engraving___nl"
  }, {
    path: "/eternity-rings/",
    component: _c3b527b0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRings___nl"
  }, {
    path: "/imprint/",
    component: _6b27699c,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___nl"
  }, {
    path: "/juwelen/",
    component: _370bb33d,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry___nl"
  }, {
    path: "/locatie/",
    component: _f0c52cb4,
    pathToRegexpOptions: {"strict":true},
    name: "shops___nl"
  }, {
    path: "/logout/",
    component: _7fa2b832,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogout___nl"
  }, {
    path: "/magazine/",
    component: _0e290d3b,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___nl"
  }, {
    path: "/memoireRingsFullSizeMemoires/",
    component: _204c2ee9,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsFullSizeMemoires___nl"
  }, {
    path: "/memoireRingsGrowingMemoires/",
    component: _e2f3e270,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGrowingMemoires___nl"
  }, {
    path: "/online-consultation/",
    component: _3fc61b50,
    pathToRegexpOptions: {"strict":true},
    name: "onlineConsulting___nl"
  }, {
    path: "/over-acredo/",
    component: _97c63e14,
    pathToRegexpOptions: {"strict":true},
    name: "about___nl"
  }, {
    path: "/privacy/",
    component: _7a115b31,
    pathToRegexpOptions: {"strict":true},
    name: "privacy___nl"
  }, {
    path: "/raadpleging/",
    component: _95e7c546,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___nl"
  }, {
    path: "/ringmaat/",
    component: _5117eeab,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizes___nl"
  }, {
    path: "/sapphire/",
    component: _3be8a369,
    pathToRegexpOptions: {"strict":true},
    name: "sapphire___nl"
  }, {
    path: "/shopIndividualBeBrussels/",
    component: _374ec160,
    pathToRegexpOptions: {"strict":true},
    name: "shopIndividualBeBrussels___nl"
  }, {
    path: "/sitemap/",
    component: _dbecf444,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___nl"
  }, {
    path: "/stijlen/",
    component: _f380c96e,
    pathToRegexpOptions: {"strict":true},
    name: "styles___nl"
  }, {
    path: "/sweepstake/",
    component: _794394f5,
    pathToRegexpOptions: {"strict":true},
    name: "sweepstake___nl"
  }, {
    path: "/trouwringen/",
    component: _5b2a6014,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRings___nl"
  }, {
    path: "/urban-mining/",
    component: _32a1456b,
    pathToRegexpOptions: {"strict":true},
    name: "urbanMining___nl"
  }, {
    path: "/verlanglijstje/",
    component: _42cad228,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist___nl"
  }, {
    path: "/verlovingsringen/",
    component: _4a953bed,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings___nl"
  }, {
    path: "/zweiklang/",
    component: _40971f7e,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklang___nl"
  }, {
    path: "/zweiklangConfigurator/",
    component: _7591b796,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklangConfigurator___nl"
  }, {
    path: "/about-acredo/packaging/",
    component: _30524846,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPackaging___nl"
  }, {
    path: "/about-acredo/rjc-certification/",
    component: _47784305,
    pathToRegexpOptions: {"strict":true},
    name: "aboutRjc___nl"
  }, {
    path: "/collections/engagement-rings/",
    component: _2cafaf56,
    pathToRegexpOptions: {"strict":true},
    name: "collectionsEngagementRings___nl"
  }, {
    path: "/configurator/basic/",
    component: _53a97f10,
    pathToRegexpOptions: {"strict":true},
    name: "configuratorV2___nl"
  }, {
    path: "/en/about-acredo/",
    component: _97c63e14,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/alloys/",
    component: _49a8189a,
    pathToRegexpOptions: {"strict":true},
    name: "metals___en"
  }, {
    path: "/en/collections/",
    component: _39399e3e,
    pathToRegexpOptions: {"strict":true},
    name: "collections___en"
  }, {
    path: "/en/configurator/",
    component: _438d64dc,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___en"
  }, {
    path: "/en/consultation/",
    component: _95e7c546,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___en"
  }, {
    path: "/en/diamonds/",
    component: _2b136dc6,
    pathToRegexpOptions: {"strict":true},
    name: "diamonds___en"
  }, {
    path: "/en/engagement-rings/",
    component: _4a953bed,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings___en"
  }, {
    path: "/en/engagementRingsFastDelivery/",
    component: _43e0acfd,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFastDelivery___en"
  }, {
    path: "/en/engraving/",
    component: _953488bc,
    pathToRegexpOptions: {"strict":true},
    name: "engraving___en"
  }, {
    path: "/en/eternity-rings/",
    component: _c3b527b0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRings___en"
  }, {
    path: "/en/imprint/",
    component: _6b27699c,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___en"
  }, {
    path: "/en/jewelry/",
    component: _370bb33d,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry___en"
  }, {
    path: "/en/location/",
    component: _f0c52cb4,
    pathToRegexpOptions: {"strict":true},
    name: "shops___en"
  }, {
    path: "/en/logout/",
    component: _7fa2b832,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogout___en"
  }, {
    path: "/en/magazine/",
    component: _0e290d3b,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___en"
  }, {
    path: "/en/memoireRingsFullSizeMemoires/",
    component: _204c2ee9,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsFullSizeMemoires___en"
  }, {
    path: "/en/memoireRingsGrowingMemoires/",
    component: _e2f3e270,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGrowingMemoires___en"
  }, {
    path: "/en/online-consultation/",
    component: _3fc61b50,
    pathToRegexpOptions: {"strict":true},
    name: "onlineConsulting___en"
  }, {
    path: "/en/privacy/",
    component: _7a115b31,
    pathToRegexpOptions: {"strict":true},
    name: "privacy___en"
  }, {
    path: "/en/ringsize/",
    component: _5117eeab,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizes___en"
  }, {
    path: "/en/sapphire/",
    component: _3be8a369,
    pathToRegexpOptions: {"strict":true},
    name: "sapphire___en"
  }, {
    path: "/en/shopIndividualBeBrussels/",
    component: _374ec160,
    pathToRegexpOptions: {"strict":true},
    name: "shopIndividualBeBrussels___en"
  }, {
    path: "/en/sitemap/",
    component: _dbecf444,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___en"
  }, {
    path: "/en/styles/",
    component: _f380c96e,
    pathToRegexpOptions: {"strict":true},
    name: "styles___en"
  }, {
    path: "/en/sweepstake/",
    component: _794394f5,
    pathToRegexpOptions: {"strict":true},
    name: "sweepstake___en"
  }, {
    path: "/en/urban-mining/",
    component: _32a1456b,
    pathToRegexpOptions: {"strict":true},
    name: "urbanMining___en"
  }, {
    path: "/en/wedding-rings/",
    component: _5b2a6014,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRings___en"
  }, {
    path: "/en/wishlist/",
    component: _42cad228,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist___en"
  }, {
    path: "/en/zweiklang/",
    component: _40971f7e,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklang___en"
  }, {
    path: "/engagement-rings/entwined/",
    component: _7915d67d,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsEntwined___nl"
  }, {
    path: "/engagement-rings/essentials/",
    component: _5d211e32,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsEssentials___nl"
  }, {
    path: "/engagement-rings/halo/",
    component: _6bcf2fc9,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHalo___nl"
  }, {
    path: "/engagment-rings/tension/",
    component: _70ea36a5,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsTensionRing___nl"
  }, {
    path: "/engraving/fonts/",
    component: _653a889c,
    pathToRegexpOptions: {"strict":true},
    name: "engravingFonts___nl"
  }, {
    path: "/engraving/inspiration/",
    component: _7ef91d18,
    pathToRegexpOptions: {"strict":true},
    name: "engravingInspiration___nl"
  }, {
    path: "/engraving/sayings/",
    component: _73fa276a,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSayings___nl"
  }, {
    path: "/engraving/symbols/",
    component: _64246aee,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSymbols___nl"
  }, {
    path: "/eternity-rings/bestseller/",
    component: _3e82052b,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBestseller___nl"
  }, {
    path: "/eternity-rings/budget-hoog/",
    component: _402abf4f,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetHigh___nl"
  }, {
    path: "/eternity-rings/budget-laag/",
    component: _4c0ae537,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetLow___nl"
  }, {
    path: "/eternity-rings/budget-medium/",
    component: _6abcc33c,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetMedium___nl"
  }, {
    path: "/eternity-rings/cheap/",
    component: _2cf67837,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsCheap___nl"
  }, {
    path: "/eternity-rings/colored/",
    component: _0c1785ac,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsColored___nl"
  }, {
    path: "/eternity-rings/gold/",
    component: _c9bc4eb0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGold___nl"
  }, {
    path: "/eternity-rings/half-summarized/",
    component: _c0b49cd4,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsHalfSetMemories___nl"
  }, {
    path: "/eternity-rings/platinum/",
    component: _b4c00718,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsPlatinum___nl"
  }, {
    path: "/eternity-rings/rood-goud/",
    component: _96e2b24e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRedgold___nl"
  }, {
    path: "/eternity-rings/rosegold/",
    component: _462242f7,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRosegold___nl"
  }, {
    path: "/eternity-rings/sets/",
    component: _07e9aa49,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRingsets___nl"
  }, {
    path: "/eternity-rings/signature/",
    component: _5f0967a0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSignature___nl"
  }, {
    path: "/eternity-rings/till-005-carat/",
    component: _5344e9f6,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSlim___nl"
  }, {
    path: "/eternity-rings/till-010-carat/",
    component: _88c5de06,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsConfigurator___nl"
  }, {
    path: "/eternity-rings/till-025-carat/",
    component: _44a22a86,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsExclusive___nl"
  }, {
    path: "/eternity-rings/trouwringen/",
    component: _b3bd072e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsAsWeddingRings___nl"
  }, {
    path: "/eternity-rings/wit-goud/",
    component: _948dbade,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsWhite___nl"
  }, {
    path: "/jewelry/signet/",
    component: _7e588e6e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignet___nl"
  }, {
    path: "/juwelen/025-carat/",
    component: _7fffc091,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry025Carat___nl"
  }, {
    path: "/juwelen/05-carat/",
    component: _793ea339,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry050Carat___nl"
  }, {
    path: "/juwelen/07-carat/",
    component: _b9efee8a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry070Carat___nl"
  }, {
    path: "/juwelen/1-carat/",
    component: _cf0e6a5a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry100Carat___nl"
  }, {
    path: "/juwelen/armbanden/",
    component: _0b24385e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBracelets___nl"
  }, {
    path: "/juwelen/bestseller/",
    component: _143e3600,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBestseller___nl"
  }, {
    path: "/juwelen/budget-hoog/",
    component: _15e6f024,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetHigh___nl"
  }, {
    path: "/juwelen/budget-laag/",
    component: _836a747c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetLow___nl"
  }, {
    path: "/juwelen/budget-medium/",
    component: _2214edf7,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetMedium___nl"
  }, {
    path: "/juwelen/collectie-ringen/",
    component: _1c2780f8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryCollectionRings___nl"
  }, {
    path: "/juwelen/configurator/",
    component: _13106092,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryConfigurator___nl"
  }, {
    path: "/juwelen/delicate-sets/",
    component: _5583951a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryDelicateJewels___nl"
  }, {
    path: "/juwelen/diamant-oorbellen/",
    component: _5b3eee8a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryEarrings___nl"
  }, {
    path: "/juwelen/diamanten_halsketting/",
    component: _73b76326,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryColliers___nl"
  }, {
    path: "/juwelen/exclusief/",
    component: _923be9de,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryExclusive___nl"
  }, {
    path: "/juwelen/goud/",
    component: _3ab48d3d,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryGold___nl"
  }, {
    path: "/juwelen/platin/",
    component: _1cec5e89,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPlatinum___nl"
  }, {
    path: "/juwelen/rood-goud/",
    component: _65d32e24,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRedgold___nl"
  }, {
    path: "/juwelen/rosegold/",
    component: _8522b5e8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRosegold___nl"
  }, {
    path: "/juwelen/sets/",
    component: _16be7cae,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySets___nl"
  }, {
    path: "/juwelen/signature/",
    component: _5d6d6faa,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignature___nl"
  }, {
    path: "/juwelen/wit-goud/",
    component: _2a17aefc,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryWhitegold___nl"
  }, {
    path: "/over-acredo/duurzaamheid/",
    component: _0a222abd,
    pathToRegexpOptions: {"strict":true},
    name: "aboutSustainability___nl"
  }, {
    path: "/over-acredo/filosofie/",
    component: _ecab62f2,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPhilosophy___nl"
  }, {
    path: "/over-acredo/juwelenproductie/",
    component: _aac1d8ac,
    pathToRegexpOptions: {"strict":true},
    name: "aboutJewelryManufacturing___nl"
  }, {
    path: "/over-acredo/kwaliteit/",
    component: _9419e04e,
    pathToRegexpOptions: {"strict":true},
    name: "aboutQuality___nl"
  }, {
    path: "/over-acredo/ontwerp/",
    component: _57b4b154,
    pathToRegexpOptions: {"strict":true},
    name: "aboutDesign___nl"
  }, {
    path: "/over-acredo/service/",
    component: _64604a8f,
    pathToRegexpOptions: {"strict":true},
    name: "aboutService___nl"
  }, {
    path: "/over-acredo/trouwringen-productie/",
    component: _a9cc87e0,
    pathToRegexpOptions: {"strict":true},
    name: "aboutWeddingRingManufacturing___nl"
  }, {
    path: "/ringmaat/calculator/",
    component: _058f190d,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesCalculator___nl"
  }, {
    path: "/ringmaat/chart/",
    component: _a8aa61da,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesTable___nl"
  }, {
    path: "/stijlen/uw-individuele-stijl/",
    component: _6b5d9f82,
    pathToRegexpOptions: {"strict":true},
    name: "stylesIndividualStyle___nl"
  }, {
    path: "/trouwringe/zwart/",
    component: _65e7d859,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBlack___nl"
  }, {
    path: "/trouwringen/afwerkingen/",
    component: _3e7c7e17,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFinishes___nl"
  }, {
    path: "/trouwringen/bestseller/",
    component: _3ca1010e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBestseller___nl"
  }, {
    path: "/trouwringen/bos_groen/",
    component: _6b531040,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsForestGreen___nl"
  }, {
    path: "/trouwringen/budget-hoog/",
    component: _394f8cc6,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetHigh___nl"
  }, {
    path: "/trouwringen/budget-laag/",
    component: _0f3de929,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetLow___nl"
  }, {
    path: "/trouwringen/budget-medium/",
    component: _5859bd30,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetMedium___nl"
  }, {
    path: "/trouwringen/carbon/",
    component: _b09ba6fa,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCarbon___nl"
  }, {
    path: "/trouwringen/certificaat/",
    component: _9c1af71e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCertificate___nl"
  }, {
    path: "/trouwringen/configurator/",
    component: _49552fcb,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsConfigurator___nl"
  }, {
    path: "/trouwringen/crown/",
    component: _7055c511,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCrown___nl"
  }, {
    path: "/trouwringen/diamanten/",
    component: _96c7ef96,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsDiamonds___nl"
  }, {
    path: "/trouwringen/diversiteit/",
    component: _24cf409e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGayLesbianCouples___nl"
  }, {
    path: "/trouwringen/exclusief/",
    component: _07d52e78,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsExclusive___nl"
  }, {
    path: "/trouwringen/fancy/",
    component: _1e7a1bba,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFancy___nl"
  }, {
    path: "/trouwringen/frame-instellingen/",
    component: _bc9b9aec,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFrameSettings___nl"
  }, {
    path: "/trouwringen/gewoon/",
    component: _e7e576b8,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlain___nl"
  }, {
    path: "/trouwringen/goedkoop/",
    component: _2b1d4529,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCheap___nl"
  }, {
    path: "/trouwringen/goud/",
    component: _b956b514,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGold___nl"
  }, {
    path: "/trouwringen/hartje/",
    component: _2f718803,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsHearts___nl"
  }, {
    path: "/trouwringen/klassiek/",
    component: _ae029228,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsClassic___nl"
  }, {
    path: "/trouwringen/mannen/",
    component: _7378d9a0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMen___nl"
  }, {
    path: "/trouwringen/milgrain/",
    component: _fdc2550c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMillgrif___nl"
  }, {
    path: "/trouwringen/modern/",
    component: _43cf7135,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsModern___nl"
  }, {
    path: "/trouwringen/mokume-gane/",
    component: _4a28af6b,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMokumeGane___nl"
  }, {
    path: "/trouwringen/platinum/",
    component: _ea389b7c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlatinum___nl"
  }, {
    path: "/trouwringen/ring-sets/",
    component: _1df07792,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRingSets___nl"
  }, {
    path: "/trouwringen/rose-goud/",
    component: _7794016a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRedgold___nl"
  }, {
    path: "/trouwringen/rose-goud/",
    component: _2b65f8c5,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRosegold___nl"
  }, {
    path: "/trouwringen/secret-heart/",
    component: _0138ca60,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSecretHeart___nl"
  }, {
    path: "/trouwringen/signature/",
    component: _223c6b92,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSignature___nl"
  }, {
    path: "/trouwringen/slank/",
    component: _42df505a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSlim___nl"
  }, {
    path: "/trouwringen/stapel-ringen/",
    component: _0e5b7d63,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStackingRings___nl"
  }, {
    path: "/trouwringen/starry_skies/",
    component: _cda535bc,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStarrySky___nl"
  }, {
    path: "/trouwringen/tension/",
    component: _42bb0da7,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTensionRings___nl"
  }, {
    path: "/trouwringen/trisets/",
    component: _989ed414,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingstrisets___nl"
  }, {
    path: "/trouwringen/twee_kleuren/",
    component: _894ab894,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTwoColors___nl"
  }, {
    path: "/trouwringen/vrouwen/",
    component: _458738d8,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWomen___nl"
  }, {
    path: "/trouwringen/wave/",
    component: _6eae7d2d,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWaveDesign___nl"
  }, {
    path: "/trouwringen/wit-goud/",
    component: _7b0ad263,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWhitegold___nl"
  }, {
    path: "/verlovingsringen/025-carat/",
    component: _448d9941,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings025Carat___nl"
  }, {
    path: "/verlovingsringen/05-carat/",
    component: _3dcc7be9,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings050Carat___nl"
  }, {
    path: "/verlovingsringen/07-carat/",
    component: _6795e16b,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings070Carat___nl"
  }, {
    path: "/verlovingsringen/1-carat/",
    component: _5d06a383,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings100Carat___nl"
  }, {
    path: "/verlovingsringen/bestseller/",
    component: _268ebaa0,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBestseller___nl"
  }, {
    path: "/verlovingsringen/brillant/",
    component: _6356eed7,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamond___nl"
  }, {
    path: "/verlovingsringen/budget-hoog/",
    component: _233d4658,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetHigh___nl"
  }, {
    path: "/verlovingsringen/budget-laag/",
    component: _e90ff9dc,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetLow___nl"
  }, {
    path: "/verlovingsringen/budget-medium/",
    component: _74b222b2,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetMedium___nl"
  }, {
    path: "/verlovingsringen/classic/",
    component: _34cf91d6,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsClassic___nl"
  }, {
    path: "/verlovingsringen/collectie-ringen/",
    component: _10b4fb70,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsCollectionRings___nl"
  }, {
    path: "/verlovingsringen/configurator/",
    component: _92bb3d7c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsConfigurator___nl"
  }, {
    path: "/verlovingsringen/dainty/",
    component: _22df3598,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDainty___nl"
  }, {
    path: "/verlovingsringen/diamanten/",
    component: _0b328d2c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamonds___nl"
  }, {
    path: "/verlovingsringen/exclusief/",
    component: _f7e16f3e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsExclusive___nl"
  }, {
    path: "/verlovingsringen/fancy/",
    component: _3ee0688c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFancy___nl"
  }, {
    path: "/verlovingsringen/goud/",
    component: _302b8426,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsGold___nl"
  }, {
    path: "/verlovingsringen/hart-ringen/",
    component: _708f3389,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHeart___nl"
  }, {
    path: "/verlovingsringen/modern/",
    component: _8d3e7028,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsModern___nl"
  }, {
    path: "/verlovingsringen/platinum/",
    component: _3d0b918e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPlatinum___nl"
  }, {
    path: "/verlovingsringen/princess/",
    component: _39130ff6,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPrincess___nl"
  }, {
    path: "/verlovingsringen/rood-goud/",
    component: _00cf7f74,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRedgold___nl"
  }, {
    path: "/verlovingsringen/rose-gold/",
    component: _fc070488,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRosegold___nl"
  }, {
    path: "/verlovingsringen/signature/",
    component: _c312f50a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSignature___nl"
  }, {
    path: "/verlovingsringen/solitaire/",
    component: _7f88614e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSolitaire___nl"
  }, {
    path: "/verlovingsringen/vintage/",
    component: _49924b29,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsVintage___nl"
  }, {
    path: "/verlovingsringen/wit-goud/",
    component: _11762768,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsWhitegold___nl"
  }, {
    path: "/wedding-rings/ceramic/",
    component: _484d72f0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCeramic___nl"
  }, {
    path: "/wedding-rings/facetes/",
    component: _dc9ca502,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacetes___nl"
  }, {
    path: "/wedding-rings/facetted-connections/",
    component: _5097b493,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacettedConnections___nl"
  }, {
    path: "/wedding-rings/morning-glow/",
    component: _3480654b,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMorningGlow___nl"
  }, {
    path: "/wedding-rings/natural-beige/",
    component: _05350ad1,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsNaturalBeige___nl"
  }, {
    path: "/wedding-rings/polar/",
    component: _07b21fd0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPolar___nl"
  }, {
    path: "/about-acredo/sustainability/plant-my-tree/",
    component: _587cc6e2,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPlantMyTree___nl"
  }, {
    path: "/en/about-acredo/design/",
    component: _57b4b154,
    pathToRegexpOptions: {"strict":true},
    name: "aboutDesign___en"
  }, {
    path: "/en/about-acredo/jewelry-production/",
    component: _aac1d8ac,
    pathToRegexpOptions: {"strict":true},
    name: "aboutJewelryManufacturing___en"
  }, {
    path: "/en/about-acredo/packaging/",
    component: _30524846,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPackaging___en"
  }, {
    path: "/en/about-acredo/philosophy/",
    component: _ecab62f2,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPhilosophy___en"
  }, {
    path: "/en/about-acredo/quality/",
    component: _9419e04e,
    pathToRegexpOptions: {"strict":true},
    name: "aboutQuality___en"
  }, {
    path: "/en/about-acredo/rjc-certification/",
    component: _47784305,
    pathToRegexpOptions: {"strict":true},
    name: "aboutRjc___en"
  }, {
    path: "/en/about-acredo/service/",
    component: _64604a8f,
    pathToRegexpOptions: {"strict":true},
    name: "aboutService___en"
  }, {
    path: "/en/about-acredo/sustainability/",
    component: _0a222abd,
    pathToRegexpOptions: {"strict":true},
    name: "aboutSustainability___en"
  }, {
    path: "/en/about-acredo/wedding-rings-production/",
    component: _a9cc87e0,
    pathToRegexpOptions: {"strict":true},
    name: "aboutWeddingRingManufacturing___en"
  }, {
    path: "/en/collections/engagement-rings/",
    component: _2cafaf56,
    pathToRegexpOptions: {"strict":true},
    name: "collectionsEngagementRings___en"
  }, {
    path: "/en/configurator/basic/",
    component: _53a97f10,
    pathToRegexpOptions: {"strict":true},
    name: "configuratorV2___en"
  }, {
    path: "/en/engagement-rings/025-carat/",
    component: _448d9941,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings025Carat___en"
  }, {
    path: "/en/engagement-rings/05-carat/",
    component: _3dcc7be9,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings050Carat___en"
  }, {
    path: "/en/engagement-rings/07-carat/",
    component: _6795e16b,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings070Carat___en"
  }, {
    path: "/en/engagement-rings/1-carat/",
    component: _5d06a383,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings100Carat___en"
  }, {
    path: "/en/engagement-rings/bestseller/",
    component: _268ebaa0,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBestseller___en"
  }, {
    path: "/en/engagement-rings/brillant/",
    component: _6356eed7,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamond___en"
  }, {
    path: "/en/engagement-rings/budget-high/",
    component: _233d4658,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetHigh___en"
  }, {
    path: "/en/engagement-rings/budget-low/",
    component: _e90ff9dc,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetLow___en"
  }, {
    path: "/en/engagement-rings/budget-medium/",
    component: _74b222b2,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetMedium___en"
  }, {
    path: "/en/engagement-rings/classic/",
    component: _34cf91d6,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsClassic___en"
  }, {
    path: "/en/engagement-rings/collection-rings/",
    component: _10b4fb70,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsCollectionRings___en"
  }, {
    path: "/en/engagement-rings/configurator/",
    component: _92bb3d7c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsConfigurator___en"
  }, {
    path: "/en/engagement-rings/dainty/",
    component: _22df3598,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDainty___en"
  }, {
    path: "/en/engagement-rings/diamonds/",
    component: _0b328d2c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamonds___en"
  }, {
    path: "/en/engagement-rings/entwined/",
    component: _7915d67d,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsEntwined___en"
  }, {
    path: "/en/engagement-rings/essentials/",
    component: _5d211e32,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsEssentials___en"
  }, {
    path: "/en/engagement-rings/exclusive/",
    component: _f7e16f3e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsExclusive___en"
  }, {
    path: "/en/engagement-rings/fancy/",
    component: _3ee0688c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFancy___en"
  }, {
    path: "/en/engagement-rings/gold/",
    component: _302b8426,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsGold___en"
  }, {
    path: "/en/engagement-rings/halo/",
    component: _6bcf2fc9,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHalo___en"
  }, {
    path: "/en/engagement-rings/heart-rings/",
    component: _708f3389,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHeart___en"
  }, {
    path: "/en/engagement-rings/modern/",
    component: _8d3e7028,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsModern___en"
  }, {
    path: "/en/engagement-rings/platinum/",
    component: _3d0b918e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPlatinum___en"
  }, {
    path: "/en/engagement-rings/princess/",
    component: _39130ff6,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPrincess___en"
  }, {
    path: "/en/engagement-rings/red-gold/",
    component: _00cf7f74,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRedgold___en"
  }, {
    path: "/en/engagement-rings/rose-gold/",
    component: _fc070488,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRosegold___en"
  }, {
    path: "/en/engagement-rings/signature/",
    component: _c312f50a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSignature___en"
  }, {
    path: "/en/engagement-rings/solitaire/",
    component: _7f88614e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSolitaire___en"
  }, {
    path: "/en/engagement-rings/vintage/",
    component: _49924b29,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsVintage___en"
  }, {
    path: "/en/engagement-rings/white-gold/",
    component: _11762768,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsWhitegold___en"
  }, {
    path: "/en/engagment-rings/tension/",
    component: _70ea36a5,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsTensionRing___en"
  }, {
    path: "/en/engraving/fonts/",
    component: _653a889c,
    pathToRegexpOptions: {"strict":true},
    name: "engravingFonts___en"
  }, {
    path: "/en/engraving/inspiration/",
    component: _7ef91d18,
    pathToRegexpOptions: {"strict":true},
    name: "engravingInspiration___en"
  }, {
    path: "/en/engraving/sayings/",
    component: _73fa276a,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSayings___en"
  }, {
    path: "/en/engraving/symbols/",
    component: _64246aee,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSymbols___en"
  }, {
    path: "/en/eternity-rings/bestseller/",
    component: _3e82052b,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBestseller___en"
  }, {
    path: "/en/eternity-rings/budget-high/",
    component: _402abf4f,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetHigh___en"
  }, {
    path: "/en/eternity-rings/budget-low/",
    component: _4c0ae537,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetLow___en"
  }, {
    path: "/en/eternity-rings/budget-medium/",
    component: _6abcc33c,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetMedium___en"
  }, {
    path: "/en/eternity-rings/cheap/",
    component: _2cf67837,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsCheap___en"
  }, {
    path: "/en/eternity-rings/colored/",
    component: _0c1785ac,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsColored___en"
  }, {
    path: "/en/eternity-rings/gold/",
    component: _c9bc4eb0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGold___en"
  }, {
    path: "/en/eternity-rings/half-summarized/",
    component: _c0b49cd4,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsHalfSetMemories___en"
  }, {
    path: "/en/eternity-rings/platinum/",
    component: _b4c00718,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsPlatinum___en"
  }, {
    path: "/en/eternity-rings/redgold/",
    component: _96e2b24e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRedgold___en"
  }, {
    path: "/en/eternity-rings/rosegold/",
    component: _462242f7,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRosegold___en"
  }, {
    path: "/en/eternity-rings/sets/",
    component: _07e9aa49,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRingsets___en"
  }, {
    path: "/en/eternity-rings/signature/",
    component: _5f0967a0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSignature___en"
  }, {
    path: "/en/eternity-rings/till-005-carat/",
    component: _5344e9f6,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSlim___en"
  }, {
    path: "/en/eternity-rings/till-010-carat/",
    component: _88c5de06,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsConfigurator___en"
  }, {
    path: "/en/eternity-rings/till-025-carat/",
    component: _44a22a86,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsExclusive___en"
  }, {
    path: "/en/eternity-rings/wedding-rings/",
    component: _b3bd072e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsAsWeddingRings___en"
  }, {
    path: "/en/eternity-rings/white-gold/",
    component: _948dbade,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsWhite___en"
  }, {
    path: "/en/jewelry/025-carat/",
    component: _7fffc091,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry025Carat___en"
  }, {
    path: "/en/jewelry/05-carat/",
    component: _793ea339,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry050Carat___en"
  }, {
    path: "/en/jewelry/07-carat/",
    component: _b9efee8a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry070Carat___en"
  }, {
    path: "/en/jewelry/1-carat/",
    component: _cf0e6a5a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry100Carat___en"
  }, {
    path: "/en/jewelry/bestseller/",
    component: _143e3600,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBestseller___en"
  }, {
    path: "/en/jewelry/bracelets/",
    component: _0b24385e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBracelets___en"
  }, {
    path: "/en/jewelry/budget-high/",
    component: _15e6f024,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetHigh___en"
  }, {
    path: "/en/jewelry/budget-low/",
    component: _836a747c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetLow___en"
  }, {
    path: "/en/jewelry/budget-medium/",
    component: _2214edf7,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetMedium___en"
  }, {
    path: "/en/jewelry/collection-rings/",
    component: _1c2780f8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryCollectionRings___en"
  }, {
    path: "/en/jewelry/configurator/",
    component: _13106092,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryConfigurator___en"
  }, {
    path: "/en/jewelry/delicate-sets/",
    component: _5583951a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryDelicateJewels___en"
  }, {
    path: "/en/jewelry/diamond-earrings/",
    component: _5b3eee8a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryEarrings___en"
  }, {
    path: "/en/jewelry/diamond-necklace/",
    component: _73b76326,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryColliers___en"
  }, {
    path: "/en/jewelry/exclusive/",
    component: _923be9de,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryExclusive___en"
  }, {
    path: "/en/jewelry/gold/",
    component: _3ab48d3d,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryGold___en"
  }, {
    path: "/en/jewelry/platin/",
    component: _1cec5e89,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPlatinum___en"
  }, {
    path: "/en/jewelry/redgold/",
    component: _65d32e24,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRedgold___en"
  }, {
    path: "/en/jewelry/rosegold/",
    component: _8522b5e8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRosegold___en"
  }, {
    path: "/en/jewelry/sets/",
    component: _16be7cae,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySets___en"
  }, {
    path: "/en/jewelry/signature/",
    component: _5d6d6faa,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignature___en"
  }, {
    path: "/en/jewelry/signet/",
    component: _7e588e6e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignet___en"
  }, {
    path: "/en/jewelry/white-gold/",
    component: _2a17aefc,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryWhitegold___en"
  }, {
    path: "/en/ringsize/calculator/",
    component: _058f190d,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesCalculator___en"
  }, {
    path: "/en/ringsize/chart/",
    component: _a8aa61da,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesTable___en"
  }, {
    path: "/en/styles/your-individual-style/",
    component: _6b5d9f82,
    pathToRegexpOptions: {"strict":true},
    name: "stylesIndividualStyle___en"
  }, {
    path: "/en/trauringe-eheringe/schwarz/",
    component: _65e7d859,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBlack___en"
  }, {
    path: "/en/trauringe-eheringe/zertifikat/",
    component: _9c1af71e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCertificate___en"
  }, {
    path: "/en/wedding-rings/bestseller/",
    component: _3ca1010e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBestseller___en"
  }, {
    path: "/en/wedding-rings/budget-high/",
    component: _394f8cc6,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetHigh___en"
  }, {
    path: "/en/wedding-rings/budget-low/",
    component: _0f3de929,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetLow___en"
  }, {
    path: "/en/wedding-rings/budget-medium/",
    component: _5859bd30,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetMedium___en"
  }, {
    path: "/en/wedding-rings/carbon/",
    component: _b09ba6fa,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCarbon___en"
  }, {
    path: "/en/wedding-rings/ceramic/",
    component: _484d72f0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCeramic___en"
  }, {
    path: "/en/wedding-rings/cheap/",
    component: _2b1d4529,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCheap___en"
  }, {
    path: "/en/wedding-rings/classic/",
    component: _ae029228,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsClassic___en"
  }, {
    path: "/en/wedding-rings/configurator/",
    component: _49552fcb,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsConfigurator___en"
  }, {
    path: "/en/wedding-rings/crown/",
    component: _7055c511,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCrown___en"
  }, {
    path: "/en/wedding-rings/diamonds/",
    component: _96c7ef96,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsDiamonds___en"
  }, {
    path: "/en/wedding-rings/diversity/",
    component: _24cf409e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGayLesbianCouples___en"
  }, {
    path: "/en/wedding-rings/exclusive/",
    component: _07d52e78,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsExclusive___en"
  }, {
    path: "/en/wedding-rings/facetes/",
    component: _dc9ca502,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacetes___en"
  }, {
    path: "/en/wedding-rings/facetted-connections/",
    component: _5097b493,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacettedConnections___en"
  }, {
    path: "/en/wedding-rings/fancy/",
    component: _1e7a1bba,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFancy___en"
  }, {
    path: "/en/wedding-rings/forest_green/",
    component: _6b531040,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsForestGreen___en"
  }, {
    path: "/en/wedding-rings/frame_settings/",
    component: _bc9b9aec,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFrameSettings___en"
  }, {
    path: "/en/wedding-rings/gold/",
    component: _b956b514,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGold___en"
  }, {
    path: "/en/wedding-rings/hammered/",
    component: _3e7c7e17,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFinishes___en"
  }, {
    path: "/en/wedding-rings/hearts/",
    component: _2f718803,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsHearts___en"
  }, {
    path: "/en/wedding-rings/men/",
    component: _7378d9a0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMen___en"
  }, {
    path: "/en/wedding-rings/milgrain/",
    component: _fdc2550c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMillgrif___en"
  }, {
    path: "/en/wedding-rings/modern/",
    component: _43cf7135,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsModern___en"
  }, {
    path: "/en/wedding-rings/mokume-gane/",
    component: _4a28af6b,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMokumeGane___en"
  }, {
    path: "/en/wedding-rings/morning-glow/",
    component: _3480654b,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMorningGlow___en"
  }, {
    path: "/en/wedding-rings/natural-beige/",
    component: _05350ad1,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsNaturalBeige___en"
  }, {
    path: "/en/wedding-rings/plain/",
    component: _e7e576b8,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlain___en"
  }, {
    path: "/en/wedding-rings/platinum/",
    component: _ea389b7c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlatinum___en"
  }, {
    path: "/en/wedding-rings/polar/",
    component: _07b21fd0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPolar___en"
  }, {
    path: "/en/wedding-rings/red-gold/",
    component: _7794016a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRedgold___en"
  }, {
    path: "/en/wedding-rings/ring-sets/",
    component: _1df07792,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRingSets___en"
  }, {
    path: "/en/wedding-rings/rose-gold/",
    component: _2b65f8c5,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRosegold___en"
  }, {
    path: "/en/wedding-rings/secret-heart/",
    component: _0138ca60,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSecretHeart___en"
  }, {
    path: "/en/wedding-rings/signature/",
    component: _223c6b92,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSignature___en"
  }, {
    path: "/en/wedding-rings/slim/",
    component: _42df505a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSlim___en"
  }, {
    path: "/en/wedding-rings/stacking-rings/",
    component: _0e5b7d63,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStackingRings___en"
  }, {
    path: "/en/wedding-rings/starry_skies/",
    component: _cda535bc,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStarrySky___en"
  }, {
    path: "/en/wedding-rings/tension/",
    component: _42bb0da7,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTensionRings___en"
  }, {
    path: "/en/wedding-rings/trisets/",
    component: _989ed414,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingstrisets___en"
  }, {
    path: "/en/wedding-rings/two_colors/",
    component: _894ab894,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTwoColors___en"
  }, {
    path: "/en/wedding-rings/wave/",
    component: _6eae7d2d,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWaveDesign___en"
  }, {
    path: "/en/wedding-rings/white-gold/",
    component: _7b0ad263,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWhitegold___en"
  }, {
    path: "/en/wedding-rings/women/",
    component: _458738d8,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWomen___en"
  }, {
    path: "/en/zweiklang/configurator/",
    component: _7591b796,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklangConfigurator___en"
  }, {
    path: "/juwelen/presenteert/jaarlijks/",
    component: _146d8d5f,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsYearly___nl"
  }, {
    path: "/juwelen/presenteert/kerstmis/",
    component: _043c5abd,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsChristmas___nl"
  }, {
    path: "/juwelen/presenteert/moederdag/",
    component: _040c0918,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsMother___nl"
  }, {
    path: "/juwelen/presenteert/valentijnsdag/",
    component: _dfda0a9e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsValentine___nl"
  }, {
    path: "/juwelen/presenteert/vrouwen/",
    component: _2f2c8a8e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsWomen___nl"
  }, {
    path: "/trouwringen/styles/cool/",
    component: _2e33dc61,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCool___nl"
  }, {
    path: "/trouwringen/styles/creatief/",
    component: _e66f0c72,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCreative___nl"
  }, {
    path: "/trouwringen/styles/elegant/",
    component: _c7f15b54,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesElegant___nl"
  }, {
    path: "/trouwringen/styles/luxe/",
    component: _77f45e25,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesLuxury___nl"
  }, {
    path: "/trouwringen/styles/natuurlijk/",
    component: _23e6e741,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesNatural___nl"
  }, {
    path: "/trouwringen/styles/romantic/",
    component: _b7be2aee,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesRomantic___nl"
  }, {
    path: "/trouwringen/styles/urban/",
    component: _7da9deea,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesUrban___nl"
  }, {
    path: "/en/about-acredo/sustainability/plant-my-tree/",
    component: _587cc6e2,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPlantMyTree___en"
  }, {
    path: "/en/jewelry/presents/christmas/",
    component: _043c5abd,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsChristmas___en"
  }, {
    path: "/en/jewelry/presents/forher/",
    component: _2f2c8a8e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsWomen___en"
  }, {
    path: "/en/jewelry/presents/motherday/",
    component: _040c0918,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsMother___en"
  }, {
    path: "/en/jewelry/presents/valentinesday/",
    component: _dfda0a9e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsValentine___en"
  }, {
    path: "/en/jewelry/presents/yearly/",
    component: _146d8d5f,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsYearly___en"
  }, {
    path: "/en/wedding-rings/styles/cool/",
    component: _2e33dc61,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCool___en"
  }, {
    path: "/en/wedding-rings/styles/creative/",
    component: _e66f0c72,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCreative___en"
  }, {
    path: "/en/wedding-rings/styles/elegant/",
    component: _c7f15b54,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesElegant___en"
  }, {
    path: "/en/wedding-rings/styles/luxury/",
    component: _77f45e25,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesLuxury___en"
  }, {
    path: "/en/wedding-rings/styles/natural/",
    component: _23e6e741,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesNatural___en"
  }, {
    path: "/en/wedding-rings/styles/romantic/",
    component: _b7be2aee,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesRomantic___en"
  }, {
    path: "/en/wedding-rings/styles/urban/",
    component: _7da9deea,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesUrban___en"
  }, {
    path: "/",
    component: _5856888a,
    pathToRegexpOptions: {"strict":true},
    name: "index___nl"
  }, {
    path: "/en/article/:set/",
    component: _4f8b36db,
    pathToRegexpOptions: {"strict":true},
    name: "item___en"
  }, {
    path: "/en/location/:town/",
    component: _4935da0d,
    pathToRegexpOptions: {"strict":true},
    name: "shopsDetails___en"
  }, {
    path: "/en/login/:shopid/",
    component: _271d429b,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogin___en"
  }, {
    path: "/en/wishlist/:wishlistHash/",
    component: _793b1fb6,
    pathToRegexpOptions: {"strict":true},
    name: "wishlistDetails___en"
  }, {
    path: "/article/:set/",
    component: _4f8b36db,
    pathToRegexpOptions: {"strict":true},
    name: "item___nl"
  }, {
    path: "/locatie/:town/",
    component: _4935da0d,
    pathToRegexpOptions: {"strict":true},
    name: "shopsDetails___nl"
  }, {
    path: "/login/:shopid/",
    component: _271d429b,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogin___nl"
  }, {
    path: "/verlanglijstje/:wishlistHash/",
    component: _793b1fb6,
    pathToRegexpOptions: {"strict":true},
    name: "wishlistDetails___nl"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
